<template>
	<div class="card md-elevation-4" style="width: auto; height: 100%">
		<div style="padding: 10px">
			<span style="font-size: 24px; font-weight: 900">{{ $t("last-movements") }}</span>
		</div>
		<div style="overflow-y: auto; height: 350px">
			<div v-for="item of array" :key="item.id" class="item">
				<div v-if="item.subscription" style="display: flex; width: 100%">
					<div style="margin-top: auto; margin-bottom: auto">
						<md-icon style="color: green">trending_up</md-icon>
					</div>
					<div style="margin-top: auto; margin-bottom: auto">
						<div>
							<span style="margin-left: 5px; color: gray">{{
								moment(item.created_at).format("DD-MM-YYYY HH:mm")
							}}</span>
						</div>
						<div style="word-break: break-word; margin-left: 5px">
							<strong>{{
								item.organization && item.organization.name
									? item.organization.name.String
									: "deleted-school"
							}}</strong>
							<span>{{ $t("has-bought") }}</span>
							<strong>{{ item.subscription ? item.subscription.name : "undefined" }}</strong>
						</div>
					</div>
					<div
						style="
							width: 100px;
							margin-top: auto;
							margin-bottom: auto;
							margin-left: auto;
							margin-right: 0px;
						"
					>
						<span style="font-size: 18px">{{ "+ " + item.amount + " €" }}</span>
					</div>
				</div>
				<div v-else style="display: flex">
					<div style="margin-top: auto; margin-bottom: auto">
						<md-icon style="color: #4dd0e1">how_to_reg</md-icon>
					</div>
					<div style="margin-top: auto; margin-bottom: auto">
						<div>
							<span style="margin-left: 5px; color: gray">{{
								moment(item.created_at).format("DD-MM-YYYY HH:mm")
							}}</span>
						</div>
						<div style="margin-left: 5px">
							<span>{{ item.name.String }}</span>
							<span>{{ $t("has-been-registered") }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
export default {
	name: "movements-chart",
	computed: {
		...mapGetters({
			payments: "dashboard/paymentsNumber",
			schools: "dashboard/schoolsNumber"
		}),
		array: function () {
			var r = this.payments.lastMonthArray.concat(this.schools.lastMonthArray)
			r.sort(function (a, b) {
				return new Date(b.created_at) - new Date(a.created_at)
			})
			return r
		}
	}
}
</script>
<style scoped lang="scss">
@import "src/assets/scss/chart.scss";
.item {
	display: flex;
	padding: 10px;
	&:hover {
		cursor: pointer;
		background-color: rgba(92, 92, 92, 0.1);
	}
}

span {
	margin: 5px;
}
</style>
